import Container from '@/components/Container'
import HtmlContent from '@/components/HtmlContent'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import React from 'react'
import style from './styles/policy.module.scss'

const PrivacyPolicy = (): React.ReactElement => {
  const page = usePage()
  const { object } = page?.init_state
  return (
    <Container>
      <Title type='h1' className={style.policy__title}>{object.title}</Title>

      <HtmlContent content={object.detail} />
    </Container>
  )
}

export default PrivacyPolicy
